import React, {useState, useEffect} from 'react';

export default function PageNotFound(props) {
    return (
        <div className="container-fluid text-center">
            <div className="row">
                <div className="col-12 col-sm-12 col-md-12" style={{marginTop: '70px'}}>
                    <p className="page-not-found">Our team is currently in the works.</p>
                    <p className="page-not-found-hint">Be back up soon.</p>
                </div>
            </div>
        </div>
    );
}